import { useQuery } from "@tanstack/react-query";
import { getNotifications } from "@/services/notification/notification.service";
import { getCookie } from "cookies-next";
import { COOKIE_CONFIG } from "@/config";

/**
 * Hook to fetch and manage the unread notification count
 * Following SOLID principles by separating data fetching and transformation
 */
export const useNotificationCount = (isLoggedIn: boolean | null) => {
  return useQuery({
    queryKey: ["unreadNotificationCount"],
    queryFn: () => getNotifications(),
    enabled: !!isLoggedIn && !!getCookie(COOKIE_CONFIG.loggedIn),
    // Map the response to just return the count for simplicity in UI components
    select: (response) => response.data.count,
    refetchOnWindowFocus: true,
  });
};
